export interface RecompensaUtilizada {
  tipo: 'pix' | 'pagamento_conta' | 'voucher' | 'curso' | 'experiencia' | 'produto';
  quantidade: number;
  valor_total: number;
}

export interface RecompensaHistoricoMensal {
  mes: string;
  pix_valor: number;
  pagamento_conta_valor: number;
  voucher_valor: number;
  curso_valor: number;
  experiencia_valor: number;
  produto_valor: number;
  total_valor: number;
}

export interface YoYDados {
  faturamento_mensal: number;
  faturamento_acumulado: number;
  participantes_ativos: number;
  novos_cadastros_mes: number;
  total_recompensas_valor: number;
  total_recompensas_quantidade: number;
}

export interface FinanceiroEmpresa {
  empresa_id: string;
  nome_fantasia: string;
  razao_social: string;
  cnpj: string;
  status: 'ativa' | 'pendente' | 'suspensa' | 'inativa';
  plano: 'basico' | 'profissional' | 'enterprise';
  
  // Faturamento
  faturamento_mensal: number;
  faturamento_acumulado: number;
  faturamento_historico: { mes: string; valor: number }[];
  
  // Cadastros
  participantes_ativos: number;
  participantes_total: number;
  novos_cadastros_mes: number;
  cadastros_historico: { mes: string; novos: number; desligados: number }[];
  
  // Recompensas
  recompensas: RecompensaUtilizada[];
  recompensas_historico: RecompensaHistoricoMensal[];
  total_recompensas_valor: number;
  total_recompensas_quantidade: number;
  
  // YoY
  yoy: YoYDados;
}

export const financeiroEmpresas: FinanceiroEmpresa[] = [
  {
    empresa_id: 'EMP-001',
    nome_fantasia: 'getPoints',
    razao_social: 'GetPoints Tecnologia S.A.',
    cnpj: '12.345.678/0001-90',
    status: 'ativa',
    plano: 'enterprise',
    faturamento_mensal: 12800.0,
    faturamento_acumulado: 75600.0,
    faturamento_historico: [
      { mes: 'Dez', valor: 9800 },
      { mes: 'Jan', valor: 10500 },
      { mes: 'Fev', valor: 11200 },
      { mes: 'Mar', valor: 11800 },
      { mes: 'Abr', valor: 12100 },
      { mes: 'Mai', valor: 12800 },
    ],
    participantes_ativos: 1247,
    participantes_total: 1500,
    novos_cadastros_mes: 88,
    cadastros_historico: [
      { mes: 'Dez', novos: 45, desligados: 12 },
      { mes: 'Jan', novos: 82, desligados: 8 },
      { mes: 'Fev', novos: 78, desligados: 15 },
      { mes: 'Mar', novos: 95, desligados: 10 },
      { mes: 'Abr', novos: 72, desligados: 18 },
      { mes: 'Mai', novos: 88, desligados: 14 },
    ],
    recompensas: [
      { tipo: 'pix', quantidade: 342, valor_total: 48500.0 },
      { tipo: 'pagamento_conta', quantidade: 89, valor_total: 15200.0 },
      { tipo: 'voucher', quantidade: 156, valor_total: 23400.0 },
      { tipo: 'curso', quantidade: 78, valor_total: 31200.0 },
      { tipo: 'experiencia', quantidade: 23, valor_total: 28700.0 },
      { tipo: 'produto', quantidade: 45, valor_total: 18900.0 },
    ],
    recompensas_historico: [
      { mes: 'Dez', pix_valor: 7200, pagamento_conta_valor: 2100, voucher_valor: 3400, curso_valor: 4800, experiencia_valor: 4200, produto_valor: 2800, total_valor: 24500 },
      { mes: 'Jan', pix_valor: 7800, pagamento_conta_valor: 2300, voucher_valor: 3600, curso_valor: 5000, experiencia_valor: 4500, produto_valor: 2900, total_valor: 26100 },
      { mes: 'Fev', pix_valor: 8000, pagamento_conta_valor: 2500, voucher_valor: 3800, curso_valor: 5200, experiencia_valor: 4800, produto_valor: 3100, total_valor: 27400 },
      { mes: 'Mar', pix_valor: 8200, pagamento_conta_valor: 2600, voucher_valor: 3900, curso_valor: 5300, experiencia_valor: 5000, produto_valor: 3200, total_valor: 28200 },
      { mes: 'Abr', pix_valor: 8400, pagamento_conta_valor: 2700, voucher_valor: 4000, curso_valor: 5400, experiencia_valor: 5100, produto_valor: 3300, total_valor: 28900 },
      { mes: 'Mai', pix_valor: 8900, pagamento_conta_valor: 3000, voucher_valor: 4300, curso_valor: 5500, experiencia_valor: 5100, produto_valor: 3500, total_valor: 30300 },
    ],
    total_recompensas_valor: 166900.0,
    total_recompensas_quantidade: 733,
    yoy: {
      faturamento_mensal: 10800,
      faturamento_acumulado: 61200,
      participantes_ativos: 1050,
      novos_cadastros_mes: 65,
      total_recompensas_valor: 138500,
      total_recompensas_quantidade: 620,
    },
  },
  {
    empresa_id: 'EMP-002',
    nome_fantasia: 'Inova Digital',
    razao_social: 'Inovação Digital S.A.',
    cnpj: '98.765.432/0001-10',
    status: 'ativa',
    plano: 'profissional',
    faturamento_mensal: 5200.0,
    faturamento_acumulado: 31200.0,
    faturamento_historico: [
      { mes: 'Dez', valor: 4200 },
      { mes: 'Jan', valor: 4500 },
      { mes: 'Fev', valor: 4700 },
      { mes: 'Mar', valor: 4900 },
      { mes: 'Abr', valor: 5000 },
      { mes: 'Mai', valor: 5200 },
    ],
    participantes_ativos: 456,
    participantes_total: 500,
    novos_cadastros_mes: 34,
    cadastros_historico: [
      { mes: 'Dez', novos: 28, desligados: 5 },
      { mes: 'Jan', novos: 32, desligados: 3 },
      { mes: 'Fev', novos: 30, desligados: 7 },
      { mes: 'Mar', novos: 35, desligados: 4 },
      { mes: 'Abr', novos: 29, desligados: 6 },
      { mes: 'Mai', novos: 34, desligados: 5 },
    ],
    recompensas: [
      { tipo: 'pix', quantidade: 128, valor_total: 18600.0 },
      { tipo: 'pagamento_conta', quantidade: 34, valor_total: 5800.0 },
      { tipo: 'voucher', quantidade: 67, valor_total: 10200.0 },
      { tipo: 'curso', quantidade: 42, valor_total: 16800.0 },
      { tipo: 'experiencia', quantidade: 12, valor_total: 15600.0 },
      { tipo: 'produto', quantidade: 19, valor_total: 7600.0 },
    ],
    recompensas_historico: [
      { mes: 'Dez', pix_valor: 2800, pagamento_conta_valor: 800, voucher_valor: 1400, curso_valor: 2600, experiencia_valor: 2300, produto_valor: 1100, total_valor: 11000 },
      { mes: 'Jan', pix_valor: 3000, pagamento_conta_valor: 900, voucher_valor: 1600, curso_valor: 2700, experiencia_valor: 2500, produto_valor: 1200, total_valor: 11900 },
      { mes: 'Fev', pix_valor: 3100, pagamento_conta_valor: 950, voucher_valor: 1700, curso_valor: 2800, experiencia_valor: 2600, produto_valor: 1250, total_valor: 12400 },
      { mes: 'Mar', pix_valor: 3150, pagamento_conta_valor: 980, voucher_valor: 1720, curso_valor: 2850, experiencia_valor: 2650, produto_valor: 1280, total_valor: 12630 },
      { mes: 'Abr', pix_valor: 3100, pagamento_conta_valor: 970, voucher_valor: 1680, curso_valor: 2800, experiencia_valor: 2620, produto_valor: 1260, total_valor: 12430 },
      { mes: 'Mai', pix_valor: 3350, pagamento_conta_valor: 1070, voucher_valor: 1800, curso_valor: 2950, experiencia_valor: 2730, produto_valor: 1350, total_valor: 13250 },
    ],
    total_recompensas_valor: 74600.0,
    total_recompensas_quantidade: 302,
    yoy: {
      faturamento_mensal: 4500,
      faturamento_acumulado: 27000,
      participantes_ativos: 380,
      novos_cadastros_mes: 28,
      total_recompensas_valor: 62500,
      total_recompensas_quantidade: 260,
    },
  },
  {
    empresa_id: 'EMP-003',
    nome_fantasia: 'TechBrasil',
    razao_social: 'Consultoria Tech Brasil Ltda.',
    cnpj: '45.678.901/0001-23',
    status: 'ativa',
    plano: 'profissional',
    faturamento_mensal: 3200.0,
    faturamento_acumulado: 19200.0,
    faturamento_historico: [
      { mes: 'Dez', valor: 2600 },
      { mes: 'Jan', valor: 2800 },
      { mes: 'Fev', valor: 2900 },
      { mes: 'Mar', valor: 3000 },
      { mes: 'Abr', valor: 3100 },
      { mes: 'Mai', valor: 3200 },
    ],
    participantes_ativos: 234,
    participantes_total: 300,
    novos_cadastros_mes: 18,
    cadastros_historico: [
      { mes: 'Dez', novos: 15, desligados: 3 },
      { mes: 'Jan', novos: 18, desligados: 2 },
      { mes: 'Fev', novos: 16, desligados: 4 },
      { mes: 'Mar', novos: 20, desligados: 3 },
      { mes: 'Abr', novos: 14, desligados: 5 },
      { mes: 'Mai', novos: 18, desligados: 2 },
    ],
    recompensas: [
      { tipo: 'pix', quantidade: 67, valor_total: 9800.0 },
      { tipo: 'pagamento_conta', quantidade: 21, valor_total: 3400.0 },
      { tipo: 'voucher', quantidade: 34, valor_total: 5100.0 },
      { tipo: 'curso', quantidade: 19, valor_total: 7600.0 },
      { tipo: 'experiencia', quantidade: 5, valor_total: 6200.0 },
      { tipo: 'produto', quantidade: 11, valor_total: 4400.0 },
    ],
    recompensas_historico: [
      { mes: 'Dez', pix_valor: 1500, pagamento_conta_valor: 500, voucher_valor: 700, curso_valor: 1200, experiencia_valor: 900, produto_valor: 600, total_valor: 5400 },
      { mes: 'Jan', pix_valor: 1600, pagamento_conta_valor: 550, voucher_valor: 800, curso_valor: 1250, experiencia_valor: 1000, produto_valor: 650, total_valor: 5850 },
      { mes: 'Fev', pix_valor: 1650, pagamento_conta_valor: 580, voucher_valor: 850, curso_valor: 1300, experiencia_valor: 1050, produto_valor: 680, total_valor: 6110 },
      { mes: 'Mar', pix_valor: 1680, pagamento_conta_valor: 590, voucher_valor: 860, curso_valor: 1320, experiencia_valor: 1080, produto_valor: 700, total_valor: 6230 },
      { mes: 'Abr', pix_valor: 1620, pagamento_conta_valor: 570, voucher_valor: 830, curso_valor: 1280, experiencia_valor: 1030, produto_valor: 670, total_valor: 6000 },
      { mes: 'Mai', pix_valor: 1750, pagamento_conta_valor: 610, voucher_valor: 920, curso_valor: 1350, experiencia_valor: 1140, produto_valor: 700, total_valor: 6470 },
    ],
    total_recompensas_valor: 36500.0,
    total_recompensas_quantidade: 157,
    yoy: {
      faturamento_mensal: 2800,
      faturamento_acumulado: 16800,
      participantes_ativos: 195,
      novos_cadastros_mes: 14,
      total_recompensas_valor: 31200,
      total_recompensas_quantidade: 135,
    },
  },
  {
    empresa_id: 'EMP-004',
    nome_fantasia: 'SysInt',
    razao_social: 'Sistemas Integrados Ltda.',
    cnpj: '23.456.789/0001-45',
    status: 'ativa',
    plano: 'basico',
    faturamento_mensal: 1200.0,
    faturamento_acumulado: 7200.0,
    faturamento_historico: [
      { mes: 'Dez', valor: 950 },
      { mes: 'Jan', valor: 1000 },
      { mes: 'Fev', valor: 1050 },
      { mes: 'Mar', valor: 1100 },
      { mes: 'Abr', valor: 1150 },
      { mes: 'Mai', valor: 1200 },
    ],
    participantes_ativos: 89,
    participantes_total: 120,
    novos_cadastros_mes: 7,
    cadastros_historico: [
      { mes: 'Dez', novos: 6, desligados: 2 },
      { mes: 'Jan', novos: 8, desligados: 1 },
      { mes: 'Fev', novos: 7, desligados: 3 },
      { mes: 'Mar', novos: 9, desligados: 1 },
      { mes: 'Abr', novos: 6, desligados: 2 },
      { mes: 'Mai', novos: 7, desligados: 1 },
    ],
    recompensas: [
      { tipo: 'pix', quantidade: 24, valor_total: 3400.0 },
      { tipo: 'pagamento_conta', quantidade: 8, valor_total: 1300.0 },
      { tipo: 'voucher', quantidade: 15, valor_total: 2200.0 },
      { tipo: 'curso', quantidade: 7, valor_total: 2800.0 },
      { tipo: 'experiencia', quantidade: 2, valor_total: 2500.0 },
      { tipo: 'produto', quantidade: 5, valor_total: 2000.0 },
    ],
    recompensas_historico: [
      { mes: 'Dez', pix_valor: 500, pagamento_conta_valor: 180, voucher_valor: 300, curso_valor: 420, experiencia_valor: 350, produto_valor: 280, total_valor: 2030 },
      { mes: 'Jan', pix_valor: 550, pagamento_conta_valor: 200, voucher_valor: 330, curso_valor: 450, experiencia_valor: 380, produto_valor: 300, total_valor: 2210 },
      { mes: 'Fev', pix_valor: 580, pagamento_conta_valor: 210, voucher_valor: 350, curso_valor: 470, experiencia_valor: 400, produto_valor: 310, total_valor: 2320 },
      { mes: 'Mar', pix_valor: 600, pagamento_conta_valor: 220, voucher_valor: 360, curso_valor: 480, experiencia_valor: 420, produto_valor: 320, total_valor: 2400 },
      { mes: 'Abr', pix_valor: 570, pagamento_conta_valor: 215, voucher_valor: 340, curso_valor: 460, experiencia_valor: 400, produto_valor: 305, total_valor: 2290 },
      { mes: 'Mai', pix_valor: 590, pagamento_conta_valor: 225, voucher_valor: 355, curso_valor: 480, experiencia_valor: 420, produto_valor: 315, total_valor: 2385 },
    ],
    total_recompensas_valor: 14200.0,
    total_recompensas_quantidade: 61,
    yoy: {
      faturamento_mensal: 1050,
      faturamento_acumulado: 6300,
      participantes_ativos: 72,
      novos_cadastros_mes: 5,
      total_recompensas_valor: 12100,
      total_recompensas_quantidade: 52,
    },
  },
  {
    empresa_id: 'EMP-005',
    nome_fantasia: 'Expresso Distribuidora',
    razao_social: 'Distribuidora Expresso LTDA',
    cnpj: '67.890.123/0001-67',
    status: 'pendente',
    plano: 'profissional',
    faturamento_mensal: 0,
    faturamento_acumulado: 0,
    faturamento_historico: [
      { mes: 'Dez', valor: 0 },
      { mes: 'Jan', valor: 0 },
      { mes: 'Fev', valor: 0 },
      { mes: 'Mar', valor: 0 },
      { mes: 'Abr', valor: 0 },
      { mes: 'Mai', valor: 0 },
    ],
    participantes_ativos: 0,
    participantes_total: 0,
    novos_cadastros_mes: 0,
    cadastros_historico: [
      { mes: 'Dez', novos: 0, desligados: 0 },
      { mes: 'Jan', novos: 0, desligados: 0 },
      { mes: 'Fev', novos: 0, desligados: 0 },
      { mes: 'Mar', novos: 0, desligados: 0 },
      { mes: 'Abr', novos: 0, desligados: 0 },
      { mes: 'Mai', novos: 0, desligados: 0 },
    ],
    recompensas: [
      { tipo: 'pix', quantidade: 0, valor_total: 0 },
      { tipo: 'pagamento_conta', quantidade: 0, valor_total: 0 },
      { tipo: 'voucher', quantidade: 0, valor_total: 0 },
      { tipo: 'curso', quantidade: 0, valor_total: 0 },
      { tipo: 'experiencia', quantidade: 0, valor_total: 0 },
      { tipo: 'produto', quantidade: 0, valor_total: 0 },
    ],
    recompensas_historico: [
      { mes: 'Dez', pix_valor: 0, pagamento_conta_valor: 0, voucher_valor: 0, curso_valor: 0, experiencia_valor: 0, produto_valor: 0, total_valor: 0 },
      { mes: 'Jan', pix_valor: 0, pagamento_conta_valor: 0, voucher_valor: 0, curso_valor: 0, experiencia_valor: 0, produto_valor: 0, total_valor: 0 },
      { mes: 'Fev', pix_valor: 0, pagamento_conta_valor: 0, voucher_valor: 0, curso_valor: 0, experiencia_valor: 0, produto_valor: 0, total_valor: 0 },
      { mes: 'Mar', pix_valor: 0, pagamento_conta_valor: 0, voucher_valor: 0, curso_valor: 0, experiencia_valor: 0, produto_valor: 0, total_valor: 0 },
      { mes: 'Abr', pix_valor: 0, pagamento_conta_valor: 0, voucher_valor: 0, curso_valor: 0, experiencia_valor: 0, produto_valor: 0, total_valor: 0 },
      { mes: 'Mai', pix_valor: 0, pagamento_conta_valor: 0, voucher_valor: 0, curso_valor: 0, experiencia_valor: 0, produto_valor: 0, total_valor: 0 },
    ],
    total_recompensas_valor: 0,
    total_recompensas_quantidade: 0,
    yoy: {
      faturamento_mensal: 0,
      faturamento_acumulado: 0,
      participantes_ativos: 0,
      novos_cadastros_mes: 0,
      total_recompensas_valor: 0,
      total_recompensas_quantidade: 0,
    },
  },
  {
    empresa_id: 'EMP-006',
    nome_fantasia: 'Saúde Total',
    razao_social: 'Clínica Saúde Total S.A.',
    cnpj: '34.567.890/0001-12',
    status: 'suspensa',
    plano: 'basico',
    faturamento_mensal: 800.0,
    faturamento_acumulado: 4800.0,
    faturamento_historico: [
      { mes: 'Dez', valor: 650 },
      { mes: 'Jan', valor: 700 },
      { mes: 'Fev', valor: 720 },
      { mes: 'Mar', valor: 750 },
      { mes: 'Abr', valor: 780 },
      { mes: 'Mai', valor: 800 },
    ],
    participantes_ativos: 45,
    participantes_total: 200,
    novos_cadastros_mes: 0,
    cadastros_historico: [
      { mes: 'Dez', novos: 12, desligados: 5 },
      { mes: 'Jan', novos: 8, desligados: 3 },
      { mes: 'Fev', novos: 6, desligados: 8 },
      { mes: 'Mar', novos: 4, desligados: 12 },
      { mes: 'Abr', novos: 2, desligados: 15 },
      { mes: 'Mai', novos: 0, desligados: 20 },
    ],
    recompensas: [
      { tipo: 'pix', quantidade: 12, valor_total: 1800.0 },
      { tipo: 'pagamento_conta', quantidade: 4, valor_total: 700.0 },
      { tipo: 'voucher', quantidade: 8, valor_total: 1200.0 },
      { tipo: 'curso', quantidade: 3, valor_total: 1200.0 },
      { tipo: 'experiencia', quantidade: 1, valor_total: 1500.0 },
      { tipo: 'produto', quantidade: 2, valor_total: 800.0 },
    ],
    recompensas_historico: [
      { mes: 'Dez', pix_valor: 280, pagamento_conta_valor: 100, voucher_valor: 180, curso_valor: 180, experiencia_valor: 220, produto_valor: 120, total_valor: 1080 },
      { mes: 'Jan', pix_valor: 300, pagamento_conta_valor: 110, voucher_valor: 190, curso_valor: 200, experiencia_valor: 240, produto_valor: 130, total_valor: 1170 },
      { mes: 'Fev', pix_valor: 310, pagamento_conta_valor: 120, voucher_valor: 200, curso_valor: 210, experiencia_valor: 250, produto_valor: 135, total_valor: 1225 },
      { mes: 'Mar', pix_valor: 305, pagamento_conta_valor: 115, voucher_valor: 195, curso_valor: 205, experiencia_valor: 245, produto_valor: 132, total_valor: 1197 },
      { mes: 'Abr', pix_valor: 290, pagamento_conta_valor: 110, voucher_valor: 185, curso_valor: 195, experiencia_valor: 235, produto_valor: 125, total_valor: 1140 },
      { mes: 'Mai', pix_valor: 315, pagamento_conta_valor: 145, voucher_valor: 250, curso_valor: 210, experiencia_valor: 310, produto_valor: 165, total_valor: 1395 },
    ],
    total_recompensas_valor: 6200.0,
    total_recompensas_quantidade: 30,
    yoy: {
      faturamento_mensal: 1200,
      faturamento_acumulado: 7200,
      participantes_ativos: 180,
      novos_cadastros_mes: 15,
      total_recompensas_valor: 18500,
      total_recompensas_quantidade: 85,
    },
  },
  {
    empresa_id: 'EMP-007',
    nome_fantasia: 'Educa Premium',
    razao_social: 'Educação Premium Ltda.',
    cnpj: '78.901.234/0001-56',
    status: 'inativa',
    plano: 'basico',
    faturamento_mensal: 0,
    faturamento_acumulado: 3600.0,
    faturamento_historico: [
      { mes: 'Dez', valor: 500 },
      { mes: 'Jan', valor: 500 },
      { mes: 'Fev', valor: 400 },
      { mes: 'Mar', valor: 300 },
      { mes: 'Abr', valor: 200 },
      { mes: 'Mai', valor: 0 },
    ],
    participantes_ativos: 0,
    participantes_total: 80,
    novos_cadastros_mes: 0,
    cadastros_historico: [
      { mes: 'Dez', novos: 5, desligados: 2 },
      { mes: 'Jan', novos: 3, desligados: 8 },
      { mes: 'Fev', novos: 2, desligados: 15 },
      { mes: 'Mar', novos: 1, desligados: 20 },
      { mes: 'Abr', novos: 0, desligados: 25 },
      { mes: 'Mai', novos: 0, desligados: 10 },
    ],
    recompensas: [
      { tipo: 'pix', quantidade: 0, valor_total: 0 },
      { tipo: 'pagamento_conta', quantidade: 0, valor_total: 0 },
      { tipo: 'voucher', quantidade: 0, valor_total: 0 },
      { tipo: 'curso', quantidade: 0, valor_total: 0 },
      { tipo: 'experiencia', quantidade: 0, valor_total: 0 },
      { tipo: 'produto', quantidade: 0, valor_total: 0 },
    ],
    recompensas_historico: [
      { mes: 'Dez', pix_valor: 120, pagamento_conta_valor: 40, voucher_valor: 60, curso_valor: 80, experiencia_valor: 90, produto_valor: 50, total_valor: 440 },
      { mes: 'Jan', pix_valor: 110, pagamento_conta_valor: 35, voucher_valor: 55, curso_valor: 75, experiencia_valor: 80, produto_valor: 45, total_valor: 400 },
      { mes: 'Fev', pix_valor: 90, pagamento_conta_valor: 30, voucher_valor: 45, curso_valor: 60, experiencia_valor: 65, produto_valor: 35, total_valor: 325 },
      { mes: 'Mar', pix_valor: 60, pagamento_conta_valor: 20, voucher_valor: 30, curso_valor: 40, experiencia_valor: 45, produto_valor: 25, total_valor: 220 },
      { mes: 'Abr', pix_valor: 30, pagamento_conta_valor: 10, voucher_valor: 15, curso_valor: 20, experiencia_valor: 20, produto_valor: 10, total_valor: 105 },
      { mes: 'Mai', pix_valor: 0, pagamento_conta_valor: 0, voucher_valor: 0, curso_valor: 0, experiencia_valor: 0, produto_valor: 0, total_valor: 0 },
    ],
    total_recompensas_valor: 0,
    total_recompensas_quantidade: 0,
    yoy: {
      faturamento_mensal: 800,
      faturamento_acumulado: 4800,
      participantes_ativos: 60,
      novos_cadastros_mes: 8,
      total_recompensas_valor: 5200,
      total_recompensas_quantidade: 42,
    },
  },
];

export function getFinanceiroEmpresas(): FinanceiroEmpresa[] {
  return financeiroEmpresas;
}

export function getFinanceiroEmpresaById(id: string): FinanceiroEmpresa | undefined {
  return financeiroEmpresas.find(e => e.empresa_id === id);
}

export function getRecompensaTipoLabel(tipo: string): string {
  const labels: Record<string, string> = {
    pix: 'PIX',
    pagamento_conta: 'Pagamento de Contas',
    voucher: 'Voucher',
    curso: 'Cursos',
    experiencia: 'Experiências',
    produto: 'Produtos',
  };
  return labels[tipo] || tipo;
}

export function getRecompensaTipoColor(tipo: string): { bg: string; text: string; bar: string } {
  const colors: Record<string, { bg: string; text: string; bar: string }> = {
    pix: { bg: 'bg-emerald-50', text: 'text-emerald-600', bar: 'bg-emerald-500' },
    pagamento_conta: { bg: 'bg-blue-50', text: 'text-blue-600', bar: 'bg-blue-500' },
    voucher: { bg: 'bg-amber-50', text: 'text-amber-600', bar: 'bg-amber-500' },
    curso: { bg: 'bg-violet-50', text: 'text-violet-600', bar: 'bg-violet-500' },
    experiencia: { bg: 'bg-rose-50', text: 'text-rose-600', bar: 'bg-rose-500' },
    produto: { bg: 'bg-cyan-50', text: 'text-cyan-600', bar: 'bg-cyan-500' },
  };
  return colors[tipo] || { bg: 'bg-gray-50', text: 'text-gray-600', bar: 'bg-gray-500' };
}